import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, AbstractControl, ValidatorFn } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { LoaderService } from '@teem/core/services/loader.service';
import { UserService } from '@teem/core/services/user.service';
import { messages as i18n } from '@teem/core/constants/messages';
import { country as CountryApi } from '@teem/core/constants/api';
import { UserForm } from '@teem/core/model-forms/user-form';
import { User } from '@teem/core/models/user';

@Component({
  selector: 'app-edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  styleUrls: ['./edit-user-modal.component.scss']
})
export class EditUserModalComponent implements OnInit {
  @Input() invoicesList: Array<any>;
  @Input() isProPlan: any;
  @Input() userDetails: any;
  @Output() onLoad: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('newUserForm') newUserForm: FormGroupDirective;
	editUserForm: FormGroup;
	submitted: boolean = false;
	countryListApi: string = CountryApi.endPoint;
	roles: any = [
		{ name: $localize`:@@ts.common.user:User`, id: 'user' },
		{ name: $localize`:@@ts.common.admin:Admin`, id: 'admin' },
		// { name: $localize`:@@ts.common.super_admin:Super Admin`, id: 'super_admin' },
	];

  constructor(
    private fb: FormBuilder,
		private userService: UserService,
		private loaderService: LoaderService,
		public activeModal: NgbActiveModal,
		private el:ElementRef
  ) { }

  ngOnInit(): void {
    this.editUserForm = this.fb.group(new UserForm(new User(this.userDetails)));
  }

  get f() {
    return this.editUserForm.controls;
  }

  onSubmitEditUser(form: FormGroup) {
    this.submitted = true;
    if (form.valid) {
      this.loaderService.startLoading();
      let fd = form.value;
      this.userService.updateTeemUser(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(data => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.done, i18n.user.user_updated, 'success');
        this.submitted = false;
        this.activeModal.close(data);
      }, err => {
        this.loaderService.stopLoading();
        // Set server side error
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;
            Object.keys(validationErrors).forEach((prop) => {
              form.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }
}
